import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { colors, fontSizes, fontWeights } from 'syf-component-library/defaultTheme';
import Inset from 'syf-component-library/ui/spacing/Inset/Inset';
import { Body, H5 } from 'syf-component-library/ui/typography';
export const HeaderWrapper = styled(Inset) `
  background-color: ${colors.turquoiseLightest};
  border-bottom: 1px solid ${colors.lightGrey};
`;
export const HeaderContainer = styled.div `
  display: flex;
  width: 100%;

  @media ${query.lessThanMedium} {
    flex-direction: column;
    align-items: center;
  }
`;
export const Image = styled.img `
  height: 96px;
  width: 144px;
  max-width: 190px;

  @media ${query.lessThanMedium} {
    height: 64px;
    width: 96px;
    max-width: 96px;
  }
`;
export const HeaderContent = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media ${query.lessThanMedium} {
    align-content: center;
  }
`;
export const Title = styled(H5) `
  text-align: left;
  font-size: ${fontSizes.large}px;
  font-weight: ${fontWeights.light};
  line-height: 32px;

  @media ${query.lessThanMedium} {
    text-align: center;
  }
`;
export const SubTitle = styled(Body) `
  text-align: left;

  @media ${query.lessThanMedium} {
    text-align: center;
  }
`;
